(() => {
  // Landing page only
  if (!document.body.classList.contains('template-index')) return;

  const header = document.querySelector('header-component#header-component');
  if (!header) return;

  const threshold = 24;

  const update = () => {
    const y = window.scrollY || document.documentElement.scrollTop || 0;

    if (y <= threshold) {
      header.setAttribute('transparent', '');
    } else {
      header.removeAttribute('transparent');
    }
  };

  // Initial state
  update();

  // Listen for scroll
  window.addEventListener('scroll', update, { passive: true });
})();
